/**
 * Header System - Swiss Design
 *
 * Optimized for readability and visual hierarchy
 *
 * STANDARD: For normal office use
 * STRESS: Border più evidenti, padding maggiorato
 * MOBILE: Compact headers for mobile interfaces
 */

// ============================================================================
// STANDARD HEADERS
// ============================================================================

export const SWISS_HEADER = {
  /** Sticky header with backdrop blur */
  sticky: 'sticky top-0 z-40 bg-white/98 backdrop-blur-xl border-b border-gray-200/60 shadow-[0_2px_12px_rgba(0,0,0,0.04)]',

  /** Simple header without sticky behavior */
  simple: 'bg-white border-b border-gray-200/60',

  /** Emphasized header with strong border */
  emphasized: 'bg-white border-b-2 border-gray-900',

  /** Glass header with transparency */
  glass: 'bg-white/80 backdrop-blur-xl border-b border-gray-200/60',
} as const;

// ============================================================================
// STRESS HEADERS
// ============================================================================

/**
 * Header styles per stress environments
 * Border più evidenti, padding maggiorato
 */
export const SWISS_HEADER_STRESS = {
  /** Sticky header stress con contrasto aumentato */
  sticky: 'sticky top-0 z-40 bg-white/98 backdrop-blur-xl border-b-[3px] border-gray-900 shadow-[0_4px_16px_rgba(0,0,0,0.08)]',

  /** Simple header stress */
  simple: 'bg-white border-b-[3px] border-gray-900',

  /** Emphasized header stress */
  emphasized: 'bg-white border-b-[4px] border-gray-900',

  /** Glass header stress */
  glass: 'bg-white/90 backdrop-blur-xl border-b-[3px] border-gray-300',
} as const;

// ============================================================================
// MOBILE HEADERS
// ============================================================================

/**
 * Compact headers for mobile
 */
export const SWISS_HEADER_MOBILE = {
  /** Sticky header - compact */
  sticky: 'sticky top-0 z-40 bg-white border-b-2 border-gray-900 px-3 py-2 min-h-[48px] flex items-center',

  /** Header with search */
  withSearch: 'sticky top-0 z-40 bg-white border-b-2 border-gray-900 px-3 py-2 flex flex-col gap-2',

  /** Simple header */
  simple: 'bg-white border-b border-gray-200 px-3 py-2',

  /** Title in header */
  title: 'text-lg font-bold text-gray-900 truncate',

  /** Back button area */
  backButton: 'min-w-[44px] min-h-[44px] -ml-2 flex items-center justify-center',
} as const;

export type SwissHeader = keyof typeof SWISS_HEADER;
export type SwissHeaderStress = keyof typeof SWISS_HEADER_STRESS;
export type SwissHeaderMobile = keyof typeof SWISS_HEADER_MOBILE;
